<template>
    <div class="listing-header default">
        <ul class="listing-sort nav nav-tabs justify-content-center" role="tablist" data-label="مرتب‌سازی بر اساس :">
            <li @click="orderByEvent(0)">
                <a data-toggle="tab" role="tab" aria-expanded="true" :class="{active: orderBy == 0 , show: orderBy == 0 }" aria-selected="false">پیش فرض</a>
            </li>
            <li @click="orderByEvent(1)">
                <a data-toggle="tab" role="tab" aria-expanded="false" :class="{active: orderBy == 1 , show: orderBy == 1 }" aria-selected="false">ارزان ترین</a>
            </li>
            <li @click="orderByEvent(2)">
                <a data-toggle="tab" role="tab" aria-expanded="true" :class="{active: orderBy == 2 , show: orderBy == 2 }" aria-selected="false">گرانترین</a>
            </li>
            <li @click="orderByEvent(3)">
                <a data-toggle="tab" role="tab" aria-expanded="false" :class="{active: orderBy == 3 , show: orderBy == 3 }" aria-selected="true">‌بیشترین تخفیف دار</a>
            </li>
        </ul>
    </div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    export default {
        data() {
            return {
                orderBy: 0,
            }
        },
        methods: {
            orderByEvent(typeOFOrder) {
               
                this.$parent.$data.orderBy = typeOFOrder;
                filterEventBus.$emit('createQueryStringParameter');
            },
        },
        created() {
            filterEventBus.$on('initializOrderBy', () => {
                this.orderBy = IsNullOrEmptyString(this.$route.query.OrderBy) ? 5 : this.$route.query.OrderBy;
                this.$parent.$data.orderBy = this.orderBy;
            });

            filterEventBus.$on('initializIsAvalible', () => {
                this.isAvalible = this.$route.query.IsAvalible == 'true' ? true : false;
            });
        },
        computed: {
         
        },
        beforeDestroy() {
            filterEventBus.$off('initializOrderBy');
        }
    }
</script>

<style scoped>

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        ul li a:active:hover, ul li a:focus {
            color:#fff !important;
        }
        .listing-sort {
            display:flex;
            justify-content:center;
            align-items:center;
        }
        .listing-header::before {
            content:unset;
        }
            .listing-sort li a {
            display: block;
            position: relative;
            font-size: 12px;
            line-height: 25px;
            border-radius: 5px !important;
            white-space: nowrap;
            margin: 0px 3px;
            padding: 2px 6px !important;
        }
        .listing-header::before {
            top: 15%;
        }
        .listing-header {
            padding: 10px 0 0 0;
        }
        .listing-sort li + li {
            margin-right: 0;
        }
        .listing-sort li {
            display: inline-block;
        }
    }
        ul li a {
            cursor: pointer;
        }
</style>